module.exports = __webpack_public_path__ + "img/no-order.0f053717.png";